import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { ContactForm } from "./ContactForm";
import { pageData } from "./PageData";

import { Request } from "./Request";

/*
 * - Use reducer
 *
 */

export function ContactModal({
  apiEndpoint,
  admin,
  setAdmin,
  dialogOpen,
  closeDialog,
  theme,
}) {
  const [transitioning, setTransitioning] = useState(false);
  const [sessionData, setSessionData] = useState({});
  const [responseError, setResponseError] = useState(null);
  const [pageName, setPageName] = useState("connect");

  const request = Request({
    apiEndpoint,
    setSessionData,
    setResponseError,
    setAdmin,
  });

  useEffect(() => {
    async function initSession() {
      if (!initialized) {
        const session = await request.getSession();
        if (session) {
          if (session.profiles) {
            setPageName("connect-confirm");
          }
        } else {
          setPageName("connect");
        }
      }
    }

    let initialized = false;
    initSession();

    return () => {
      initialized = true;
    };
  }, []);

  const Reset = (formik) => {
    // try https://formik.org/docs/api/withFormik
    closeDialog();
    if (formik) {
      formik.resetForm();
    }
  };

  const logout = () => {
    request.logout(() => {
      setPageName("connect");
      Reset();
    });
  };

  return (
    <ContactForm
      request={request}
      responseError={responseError}
      dialogOpen={dialogOpen}
      closeDialog={closeDialog}
      transitioning={transitioning}
      setTransitioning={setTransitioning}
      Reset={Reset}
      logout={logout}
      pageName={pageName}
      setPageName={setPageName}
      pageData={pageData(admin)}
      sessionData={sessionData}
      parentTheme={theme}
      setAdmin={setAdmin}
    />
  );
}

ContactModal.propTypes = {
  apiEndpoint: PropTypes.string,
  dialogOpen: PropTypes.bool,
  closeDialog: PropTypes.func,
};
